import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';

const styles = (theme) => ({
  banner: {
    backgroundColor: theme.palette.primary.main,
    minHeight: '40px',
    paddingBottom: '8px',
  },
  bannerText: {
    color: theme.palette.primary.contrastText,
    fontSize: '16px',
    fontWeight: 'bold',
    paddingTop: '8px',
  },
  bannerMessageWrapper: {}
});

class Banner extends React.Component {
  render() {
    const link = this.props.link;
    const message = this.props.message;

    if (!message) {
      return null;
    }

    let display = <span className={this.props.classes.bannerMessageWrapper}>{message}</span>;

    if (link) {
      display = <Link color="inherit" href={link} style={{ color: 'inherit', textDecoration: 'none' }} rel="noopener noreferrer" target="_blank">{display}</Link>;
    }

    let banner = (
      <Grid className={this.props.classes.banner} container spacing={0} justifyContent="center" >
        <Grid item xs={8}>
          <Typography className={this.props.classes.bannerText} align="center">
            {display}
          </Typography>
        </Grid>
      </Grid>
    );

    return banner;
  }
}

export default withStyles(styles)(Banner);
